import {useCallback} from 'react';

import {RolesAccount} from '@/app/auth';
import {PROJECT_TAGS} from '@/constants';
import {OnboardingVersionType} from '@/dataSource/src/api/users/constants';
import {useTrackingManager} from '@/hooks';
import {IPlaidDataDefinition, TrackingEvent} from '@/services';

export const useTrackers = (
  name?: string,
  parentId?: string,
  onboardingVersion?: OnboardingVersionType,
) => {
  const {trackEvent} = useTrackingManager();

  const trackPlaidUIEvent = useCallback(
    (eventName: TrackingEvent, error?: any, extraData?: Object) => {
      trackEvent(
        eventName,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
          user: {
            name: name ?? '',
            role: RolesAccount.PARENT,
            id: parentId ?? '',
          },
          Onboarding: {
            version: onboardingVersion,
          },
          ...(error && {
            error: {
              code: '',
              message: error,
            },
          }),
          ...(extraData && {
            extraData: {
              ...extraData,
            },
          }),
        },
        error,
      );
    },
    [name, onboardingVersion, parentId, trackEvent],
  );

  const trackPlaidEvent = useCallback(
    (eventName: TrackingEvent, plaidEvent?: IPlaidDataDefinition) => {
      trackEvent(eventName, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        user: {
          name: name ?? '',
          role: RolesAccount.PARENT,
          id: parentId ?? '',
        },
        Onboarding: {
          version: onboardingVersion,
        },
        ...(plaidEvent && {
          Plaid: plaidEvent,
        }),
      });
    },
    [name, onboardingVersion, parentId, trackEvent],
  );

  return {
    trackPlaidUIEvent,
    trackPlaidEvent,
  };
};
